<template>
    <div class="findUser">
        <div class="searchWord" :class="{searchWord_loadTRUE:load}">
            <div class="searchWordbox" :class="{loadsearchWord:!load}">
                <div>
                    <el-input placeholder="请输入姓名、电话、所属公司" v-model="searchWord"
                              @keyup.enter.native="getUserList(1)"></el-input>
                    <div class="FSpan_div" @click="getUserList(1)">
                        <div class="bGModel"></div>
                        <FSpanTil title="查找用户" :fontColor="'#fff'">查找用户</FSpanTil>
                    </div>
                </div>
            </div>
            <div class="tablebox" v-if="load">
                <el-table
                        :data="tableData"
                        border
                        style="width: 100%"
                        @selection-change="getTableCheck">
                    <el-table-column
                            type="selection"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="userName"
                            align="center"
                            label="姓名">
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="phone"
                            label="电话"
                    >
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="company"
                            label="所属公司">
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="groupName"
                            label="所属小组">
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageblock" v-if="load">
                <FPage :pageSize="pageSize" :total="total" :current-page.sync="pageIndex" @page="getPage"></FPage>
            </div>
        </div>
        <div class="btnlist">
            <FBtn title="新建组" :type="2" :IconSize="18" @click="getNewDialog(0)"></FBtn>
            <FBtn title="移动到" :IconSize="20" :type="3" @click="getMoveDialog(0)" v-if="load"
                  :disabled="!tableCheckList.length"></FBtn>
        </div>
        <FDialog :dialog="newDialog.show" @close="getNewDialog(1)" title="新建组" moveWidth="30%">
            <div>
                <el-input v-model="newDialog.gloupName" @keyup.enter.native="creatGroup"
                          placeholder="新建小组名称"></el-input>
            </div>
            <div class="sureBtn">
                <FBtn title="确定" :IconSize="20" :type="2" @click="creatGroup" :disabled="!newDialog.gloupName"></FBtn>
            </div>
        </FDialog>
        <FDialog :dialog="moveDialog.show" @close="getMoveDialog(1)" title="移动到" moveWidth="32%">
            <ul class="glouplist">
                <el-radio-group v-model="moveDialog.checkid">
                    <li v-for="item in moveDialog.checkboxGroup" :key="item.id">
                        <el-radio :label="item.id">{{item.groupName}}</el-radio>
                    </li>
                </el-radio-group>
            </ul>
            <div class="sureBtn">
                <FBtn title="确定" :IconSize="20" :type="2" @click="moveGroupMembers"
                      :disabled="!moveDialog.checkid"></FBtn>
            </div>
        </FDialog>
    </div>
</template>

<script>
    import {
        getUser,
        SetGroup,
        GetGroupList,
        GetGroupByGroupName,
        SetGroupMembers
    } from '@/assets/axios/optionManage/finduser'

    export default {
        name: 'finduser',
        components: {},
        props: [],
        data() {
            return {
                //进入页面显示
                load: false,
                //新增组
                newDialog: {
                    show: false,
                    gloupName: '',
                },
                //新增组
                moveDialog: {
                    show: false,
                    checkid: '',
                    checkboxGroup: [],
                },
                //搜索
                searchWord: '',
                //
                oldsearchWord: '',
                //表格
                tableData: [],
                //每页显示条数
                pageSize: 10,
                //总页数
                total: 1,
                //当前页码
                pageIndex: 1,
                tableCheckList: []
            }
        },
        methods: {
            //获取参数
            init() {
                this.getGroupList();
            },
            // 根据条件获取用户列表
            getUserList(type) {
                if (this.isNull(this.searchWord) && type === 1) {
                    this.getMsg('请输入查找的关键字', 'info');
                    this.searchWord = '';
                    return;
                }
                if (type === 1) {
                    this.oldsearchWord = JSON.parse(JSON.stringify(this.searchWord)) || '';
                } else {
                    this.searchWord = JSON.parse(JSON.stringify(this.oldsearchWord)) || '';
                }
                if (!this.load) {
                    this.load = true;
                }
                this.tableCheckList = [];
                getUser({
                    conditions: this.oldsearchWord,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                }).then(res => {
                    if (res.code === 200) {
                        this.total = res.data.totalCount || 0;
                        this.tableData = res.data.dataTabel || [];
                    }
                })
            },
            //分页
            getPage(pageIndex, pageSize) {
                this.pageIndex = pageIndex;
                this.pageSize = pageSize;
                this.getUserList();
            },
            // 创建组信息
            creatGroup() {
                if (this.isNull(this.newDialog.gloupName)) {
                    this.getMsg('请输入新建组名称');
                    return;
                }
                GetGroupByGroupName({
                    groupName: this.newDialog.gloupName
                }).then(res => {
                    if (res.code === 200) {
                        SetGroup({
                            groupName: this.newDialog.gloupName
                        }).then(res => {
                            if (res.code === 200) {
                                this.getMsg(res.message, 'success');
                                this.newDialog.show = false;
                            }
                        })
                    }
                })
            },
            // 获取当前用户创建的组列表
            getGroupList() {
                GetGroupList().then(res => {
                    if (res.code === 200) {
                        this.moveDialog.checkboxGroup = res.data.dataTabel;
                    }
                })
            },
            // 列表选中
            getTableCheck(val) {
                this.tableCheckList = val;
            },
            // 新增弹框
            getNewDialog(type) {
                if (type === 0) {
                    this.newDialog.show = true;
                    this.newDialog.gloupName = '';
                } else {
                    this.newDialog.show = false;
                }
            },
            // 移动弹框
            getMoveDialog(type) {
                if (type === 0) {
                    if (this.isNull(this.tableCheckList)) {
                        this.getMsg('请先选择要移动的组员');
                        return;
                    }
                    this.moveDialog.show = true;
                    this.moveDialog.checkid = '';
                } else {
                    this.moveDialog.show = false;
                }
            },
            // 移动组
            moveGroupMembers() {
                let userIds = this.tableCheckList.map((item) => {
                    return item.id;
                });
                SetGroupMembers({
                    groupId: this.moveDialog.checkid,
                    userIds: userIds
                }).then(res => {
                    if (res.code === 200) {
                        this.getMsg(res.message, 'success');
                        this.getUserList();
                        this.moveDialog.show = false;
                    }
                })
            },
        },
        mounted() {
            this.init();
        },
    }
</script>

<style lang="less">

    @searchWord_btnBack: #5679c1;

    .findUser {
        width: 100%;
        height: 100%;
        overflow: auto;

        .searchWord {
            height: calc(100% - 70px);
            padding: 3% 10%;

            .loadsearchWord {
                position: relative;
                top: 33%;
            }

            .searchWordbox {
                width: 100%;
                margin: 0 auto;
                display: inline-block;
                text-align: center;

                > div {
                    min-width: 700px;
                    width: 70%;
                    display: inline-block;
                    text-align: center;

                    .el-input {
                        float: left;
                        width: 77%;

                        .el-input__inner {
                            height: 54px;
                            font-size: 16px;
                            border: 1px solid #ccc;
                            border-top-right-radius: 0;
                            border-bottom-right-radius: 0;
                        }
                    }

                    .FSpan_div {
                        width: 23%;
                        float: left;
                        height: 54px;
                        display: inline-block;
                        background-color: @searchWord_btnBack;
                        cursor: pointer;
                        position: relative;
                        border-bottom-right-radius: 5px;
                        border-top-right-radius: 5px;
                        text-align: center;
                        max-width: 200px;

                        .bGModel {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            z-index: 2;
                            display: inline-block;
                        }

                        .FSpanTil {
                            height: 100%;
                            cursor: pointer;
                            width: auto;

                            .div_svg {
                                margin-right: 10px;
                            }

                            span {
                                letter-spacing: 3px;
                                font-size: 20px;
                                width: auto;
                            }
                        }
                    }

                    .FSpan_div:hover {
                        background-color: hsl(@searchWord_btnBack, 85%);
                    }


                }
            }

            .tablebox {
                margin-top: 30px;
                height: calc(100% - 128px);

                .el-table {
                    height: 100%;

                    td:first-child .cell {
                        padding-left: 14px;
                    }
                }
            }

            .pageblock {
                margin-top: 30px;
                text-align: center;
            }
        }

        .searchWord_loadTRUE {
            min-height: 450px;
        }

        .btnlist {
            height: 32px;
            padding: 0 2%;
            text-align: right;
        }

        .el-dialog {
            .glouplist {
                overflow-x: hidden;
                height: 400px;
                overflow-y: auto;

                .el-radio-group {
                    width: 100%;

                    .el-radio__input {
                        float: left;
                        position: relative;
                        top: 1.5px;
                    }

                    .el-radio__label {
                        width: calc(100% - 50px);
                        display: inline-block;
                        float: left;
                        .text_oneLine;
                    }
                }

                li {
                    margin-top: 16px;
                    width: 100%;

                    .el-radio {
                        width: 100%;
                    }
                }

                .bigRadio;
            }

            .sureBtn {
                text-align: right;
                margin-top: 20px;
            }
        }

    }
</style>